import { cn } from '@/lib/utils'

/** A filter chip. One shape, so the three rows cannot drift apart. */
export function Chip({
  on,
  onClick,
  children,
  testId,
}: {
  on: boolean
  onClick: () => void
  children: React.ReactNode
  testId: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={on}
      data-testid={testId}
      className={cn(
        'h-7 rounded-md px-3 text-[10.5px] font-bold transition-colors',
        on
          ? 'bg-card text-foreground shadow-[inset_0_0_0_1px_hsl(var(--border))]'
          : 'text-muted-foreground hover:text-foreground',
      )}
    >
      {children}
    </button>
  )
}
